import { Injectable } from "@angular/core";
import { ApiService } from "@youm-front/api/data-access";
import { Observable } from "rxjs";
import {
  RoomRecordingDeleteRequestDTO,
  RoomRecordingSetRequestDTO
} from "../dto";

@Injectable()
export class RoomRecordingService {
  constructor(private readonly apiService: ApiService) {}

  roomRecordingDelete(
    roomRecordingDeleteRequestDTO: RoomRecordingDeleteRequestDTO
  ): Observable<void> {
    const { roomId } = roomRecordingDeleteRequestDTO.data;

    return this.apiService.delete<void>(`rooms/${roomId}/recordings`);
  }

  roomRecordingSet(
    roomRecordingSetRequestDTO: RoomRecordingSetRequestDTO
  ): Observable<void> {
    const { roomId } = roomRecordingSetRequestDTO.data;

    return this.apiService.post<void>(`rooms/${roomId}/recordings`, {});
  }
}
